var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxActive = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "m3 7.463.994-.982 2.131 2.113L10.756 4l.994.987-5.625 5.575z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  x: 0.5,
  y: 0.5,
  fill: "#5ACCE6",
  stroke: "#5ACCE6",
  rx: 3
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  fill: "#000"
}))));
export { SvgCheckboxActive as ReactComponent };
export default __webpack_public_path__ + "assets/images/checkbox-active.svg";